<!-- 二次确认密码逻辑模块 -->
<template>
  <div class="newPwd">
    <a-form-model ref="editPassForm" :rules="rules" :model="form">
      <a-form-model-item :labelCol="{ span: 5 }" :wrapperCol="!needLabel ? { offset: 5 } : {}" :label="(needLabel && labels.newPassLabel) || ''" prop="newPass">
        <a-input @click="newPwdTip = true" v-model="form.newPass" :type="!showNewPass ? 'password' : ''" :maxLength="18" :placeholder="labels.newPassPlaceholder" autocomplete="off" />
        <SvgIcon class="iconStyle" :iconClass="!showNewPass ? 'hidePwd' : 'showPwd'" @click.stop="showNewPass = !showNewPass" />
        <a-tooltip :overlayClassName="'newPwdTooltips'" v-model="newPwdTip" trigger="click" placement="right">
          <template slot="title">
            <div>
              <div class="tips-item" :class="{ red: validatePass(form.newPass, 'length') }">
                <SvgIcon style="width: 16px;height: 16px; margin-right: 8px;" :iconClass="!validatePass(form.newPass, 'length') ? 'pwdChecked' : 'pwdError'" />
                <p>新密码长度为6-18字符</p>
              </div>
              <div class="tips-item" :class="{ red: validatePass(form.newPass, 'complex') }">
                <SvgIcon style="width: 16px;height: 16px; margin-right: 8px;" :iconClass="!validatePass(form.newPass, 'complex') ? 'pwdChecked' : 'pwdError'" />
                <p>字母/数字以及标点符号至少包含2种</p>
              </div>
            </div>
          </template>
        </a-tooltip>
      </a-form-model-item>
      <!-- TODO 密码缺少校验 -->
      <a-form-model-item :labelCol="{ span: 5 }" :wrapperCol="!needLabel ? { offset: 5 } : {}" :label="(needLabel && labels.rePassLabel) || ''" prop="repPass">
        <!-- @click="!checkTip && (checkTip = true)" @blur="checkTip = false" -->
        <a-input @click="rePwdTip = true" v-model="form.repPass" :type="!showRePass ? 'password' : ''" :maxLength="18" :placeholder="labels.rePassPlaceholder" autocomplete="off" />
        <SvgIcon class="iconStyle" :iconClass=" !showRePass ? 'hidePwd' : 'showPwd'" @click="
          showRePass=!showRePass" />
        <a-tooltip :overlayClassName="'newPwdTooltips'" v-model="rePwdTip" trigger="click" placement="right">
          <template slot="title">
            <div>
              <div class="tips-item" :class="{ red: validatePass(form.repPass, 'length') }">
                <SvgIcon style="width: 16px;height: 16px; margin-right: 8px;" :iconClass="!validatePass(form.repPass, 'length') ? 'pwdChecked' : 'pwdError'" />
                <p>新密码长度为6-18字符</p>
              </div>
              <div class="tips-item" :class="{ red: validatePass(form.repPass, 'complex') }">
                <SvgIcon style="width: 16px;height: 16px; margin-right: 8px;" :iconClass="!validatePass(form.repPass, 'complex') ? 'pwdChecked' : 'pwdError'" />
                <p>字母/数字以及标点符号至少包含2种</p>
              </div>
              <div class="tips-item" :class="{ red: validatePass(form.repPass, 'same') }">
                <SvgIcon style="width: 16px;height: 16px; margin-right: 8px;" :iconClass="!validatePass(form.repPass, 'same') ? 'pwdChecked' : 'pwdError'" />
                <p>两次输入密码一致</p>
              </div>
            </div>
          </template>
        </a-tooltip>
      </a-form-model-item>
      <!-- todo slot -->
      <a-form-model-item v-if="footer" :wrapperCol="{ offset: 5 }">
        <a-button class="verify_btn" size="large" type="primary" @click="submit">提交</a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import SvgIcon from '@/components/SvgIcon'
import { passStrLength, passComplexReg } from '@/utils/regs'
// import { modifyPass } from '@/api/user'

export default {
  props: {
    // 是否需要label
    needLabel: {
      type: Boolean,
      default: true
    },
    // 表单文案
    labels: {
      type: Object,
      default: () => (
        {
          newPassLabel: '新密码',
          newPassPlaceholder: '请输入密码',
          rePassLabel: '再次输入密码',
          rePassPlaceholder: '请再次输入密码'
        }
      )
    },
    // 是否需要底部按钮
    footer: {
      type: Boolean,
      default: true
    }
  },
  components: { SvgIcon },
  data() {
    return {
      form: {
        newPass: '',
        repPass: ''
      },
      newPwdTip: false,
      rePwdTip: false,
      showNewPass: false,
      showRePass: false,
      rules: {
        newPass: [{ required: true, validator: this.newPwdValidator, trigger: 'none' }],
        repPass: [{ required: true, validator: this.rePwdValidator, trigger: 'none' }]
      },
      // 验证信息列表
      verifyList: [
        {
          validator: (v) => (v.trim() === ''),
          msg: '请输入密码'
        },
        {
          validator: (v) => (!passStrLength.test(v.trim())),
          msg: '新密码长度为6-18字符'
        },
        {
          validator: (v) => (!passComplexReg.test(v.trim())),
          msg: '密码设置格式不符合'
        }
      ],
    }
  },
  methods: {
    resetForm() {
      this.form.newPass = ''
      this.form.repPass = ''
    },
    // 密码弹窗校验
    validatePass(pwd, ruleType) {
      const rules = {
        length: (v) => (!passStrLength.test(v.trim())),
        complex: (v) => (v.trim() === '' || !passComplexReg.test(v.trim())),
        same: (v) => (v.trim() === '' || v.trim() !== this.form.newPass)
      }
      let isPass = false
      isPass = rules[ruleType](pwd)
      return isPass
    },
    submit() {
      this.$refs['editPassForm'].validate(async valid => {
        if (valid) {
          this.$emit('submit', { ...this.form })
          // try {
          // const { repPass, ...params } = this.form
          // const res = await modifyPass(params)
          // if (res) {
          //   this.$store.dispatch('logout')
          //   this.$message.success('修改成功')
          //     setTimeout(() => {
          //       // this.$router.replace({ name: 'login' })
          //       this.resetForm()
          //     }, 500)
          //   }
          // } catch (error) {
          //   this.$emit('submit', 'fail')
          //   console.log(error)
          // }
        }
      })
    },
    async newPwdValidator(rule, value, callback) {
      const verifyList = [...this.verifyList]
      this.loopValidate(verifyList, value, callback)
    },
    async rePwdValidator(rule, value, callback) {
      const verifyList = [...this.verifyList, { validator: (v) => (v.trim() !== this.form.newPass), msg: '两次密码不一致!' }]
      this.loopValidate(verifyList, value, callback)
    },
    // 遍历校验信息
    loopValidate(verifyList, val, callback) {
      try {
        verifyList.forEach((v, k) => {
          const verifyStatus = v.validator(val)
          if (verifyStatus) {
            throw new Error(callback(new Error(v.msg)))
          }
        })
        callback()
      } catch (err) { }
    }
  }
}
</script>
<style lang="less">
.newPwdTooltips {
  .ant-tooltip-arrow {
    &::before {
      background-color: #fff !important;
    }
  }
  .ant-tooltip-inner {
    background-color: #fff;
    color: #303133;

    .tips-item {
      font-size: 14px;
      display: flex;
      align-items: center;
      &.red {
        color: #ef463a;
      }
    }
  }
}
</style>

</style>
<style lang="less" scoped>
.newPwd {
  .verify_btn {
    width: 370px;
    height: 40px;
    background: #4b7dfd;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .verify_box {
    position: relative;
    width: 370px;
    line-height: 48px;
    .verify_code {
      position: absolute;
      right: 0;
      width: auto;
      line-height: 45px;
      padding: 0 18px;
      cursor: pointer;
      background: none;
      border: none;
      color: #1564ff;
      z-index: 2;
    }
  }
  .loginIsRegister {
    padding-bottom: 34px;
    margin-bottom: 12px;
    border-bottom: 1px solid #d6dae3;
  }
  .ant-form-item {
    display: flex;
    width: 100%;
    margin-bottom: 19px;
    &.ant-form-item-with-help {
      margin-bottom: 0;
    }
    .input-box {
      display: flex;
      align-items: center;
    }
    .iconStyle {
      width: 16px;
      height: 16px;
      position: absolute;
      right: 10px;
      top: 0px;
    }
    /deep/ .ant-form-item-label {
      line-height: 48px;
    }
    // align-items: center;
    /deep/ .ant-form-item-control-wrapper {
      padding-left: 10px;
      .ant-form-item-control {
        height: 100%;
        .ant-form-explain {
          font-size: 12px;
          line-height: 22px;
        }
      }
      input {
        box-sizing: border-box;
        width: 370px;
        height: 48px;
        background: #f5f8fa;
        border-radius: 6px;
        padding-right: 30px;
      }
    }
  }
}
</style>
